export default __webpack_public_path__ + "static/LeituraDisplayTwo-Swashes-e568f051cdd20eae44a6dc00fca8ce1f.woff2";